<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('pedidos.lineaspedidos') + ' NEW'" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="LineaPedido"
        tableCode="LINEAPEDIDONEW"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :shownFields="['pedidoResumen._id','pedidoResumen.pedidonumero','pedidoResumen.codigo','estado.estado', 'numero', 'tipoLinea', 'direccionInspeccion.cp', 'direccionInspeccion.poblacion', 'direccionInspeccion.provincia', 'direccionInspeccion.comunidad', 'idExpediente', 'contratacion.codEmpleado', 'cliente.empleadoVentas', 'cliente.responsable', 'cliente.nif', 'inspectores', 'camposUsuario.cpEj', 'calificacion', 'expedienteManual', 'estadoExpediente', 'emailComunicaciones', 'emailContacto', 'administrador', 'instalador', 'mantenedor', 'asociacion', 'pedidoResumen.bcId']"
        :massiveActions="true"
        :showProgress="true"
        :controlsWidth="150"
        :searchOnInit="searchOnInit"
        :paginationFilterSort="true"
        :primary="['pedidoResumen.id', 'numero']"
      >
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="$t('common.ver') + ' Pedido'" icon-f7="eye" color="green" :href="`/pedidos/view/${item.pedidoResumen.id}/`"></f7-link>
          <f7-link
            external
            v-tooltip="'Ver Expediente'"
            v-if="item.idExpediente"
            :icon-f7="item.expedienteManual ? 'doc_plaintext' : 'checkmark_seal'"
            :color="getColorExpediente(item)"
            :href="`#!/inspecciones/view/${item.idExpediente}/`"
          ></f7-link>
          <f7-link
            v-tooltip="'Crear Exp.Manual'"
            v-if="!item.idExpediente || (item.estadoExpediente && item.estadoExpediente == 'PLANIFICADO')"
            :icon-f7="'hand_raised'"
            @click="crearExpManualConLinea(item.pedidoResumen.id, item.numero)"
          ></f7-link>
          <!-- Abrir popup facturas -->
          <f7-link icon-f7="doc_plaintext" color="red" @click="mostrarFacturas(item)" v-tooltip="'Ver Facturas'"></f7-link>
          <f7-link v-if="item.pedidoResumen.bcId" v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.verEnBC')" icon-f7="link" color="orange" @click="verEnBC(item.pedidoResumen.bcId)"></f7-link>
          <f7-link v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.enviarBC')" icon-f7="arrow_up_circle" color="purple" @click="enviarBC(item.pedidoResumen.id)"></f7-link>
        </template>
        <template v-slot:massiveActions="{selecteds}">
          <f7-button
            fill
            icon-f7="doc_chart_fill"
            text="Planificar"
            class="display-flex"
            color="blue"
            @click="planificar(selecteds)"
          ></f7-button>
          <f7-button
            fill
            icon-f7="doc_chart_fill"
            text="Planificar TPI"
            class="display-flex"
            color="blue"
            @click="planificar(selecteds, true)"
          ></f7-button>
          <f7-button
            fill
            icon-f7="envelope"
            text="Enviar email"
            class="display-flex"
            color="purple"
            @click="abrirEnvioEmail(selecteds)"
          ></f7-button>
          <f7-link @click="$refs.rlist.reload()" icon-f7="arrow_counterclockwise" v-tooltip="$t('common.actualizarTabla')"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
    <envio-mail
      v-show="true"
      ref="enviarEmail"
      :opened="enviarEmail"
      :selected="selectedItems" 
      :entityConfig="emailConfigs.pedido"
      @email-enviado="onEmailEnviado"
    ></envio-mail>
    <f7-popup tablet-fullscreen ref="popupListadoFacturas" class="popup-listado-facturas" :opened="popupListadoFacturasOpened" v-if="popupListadoFacturasOpened && numeroPedidoParaFactura" @popup:closed="popupListadoFacturasOpened = false; numeroPedidoParaFactura = null; " swipe-to-close>
      <Facturas :search-on-init="true" :is-popup="true" :shown-fields="['numeroPedido']" :mandatory-filter="{ 'numeroPedido': numeroPedidoParaFactura }" :ignore-table-filters="true"/>
    </f7-popup>
    
  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import EnvioMail from "./../../components/envio-mail.vue";
import {emailConfigs} from "./../../js/email-configs.js";
import LineaPedido from "./../../js/db/LineaPedidoNew.js";
import Facturas from "../facturas/facturas.vue";
import Pedido from "./../../js/db/Pedido.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: {
    rDynamicList,
    EnvioMail,
    Facturas
  },
  data() {
    return {
      LineaPedido,
      Pedido,
      enviarEmail: false,
      emailConfigs,
      selectedItems: [],
      popupListadoFacturasOpened: false,
      numeroPedidoParaFactura: null,
    };
  },
  props: {
    searchOnInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    abrirEnvioEmail: function(selecteds) {
      // Agrupar las líneas seleccionadas por pedido
      const pedidosMap = {};
      Object.values(selecteds).forEach(selected => {
        const pedidoId = selected.pedidoResumen.id;
        if (!pedidosMap[pedidoId]) {
          pedidosMap[pedidoId] = {
            id: pedidoId,
            codigo: selected.pedidoResumen.codigo,
            numero: selected.pedidoResumen.numero,
            numerosLinea: []
          };
        }
        // Agregar el número de línea (no el número del pedido)
        pedidosMap[pedidoId].numeroLinea = selected.numero;
        pedidosMap[pedidoId].numerosLinea.push(selected.numero);
      });
      
      // Convertir el mapa a array
      this.selectedItems = Object.values(pedidosMap);
      this.enviarEmail = true;
    },
    onEmailEnviado: function() {
      this.enviarEmail = false;
      this.selectedItems = [];
    },
    getColorExpediente: function (linea) {
       if (!linea || !linea.calificacion) {
        return "gray";
      } 
      if(linea.calificacion == 'FAVORABLE' || linea.calificacion =='FAVORABLE_CON_DEFECTOS' || linea.calificacion =='FAVORABLE_CON_REPARO' ) {
        return "green";
      }
      if(linea.calificacion == 'DESFAVORABLE') {
        return "orange";
      }
      if(linea.calificacion == 'NEGATIVO') {
        return "red";
      }

    },
    filasSeleccionadas: function() {
      // Este método ahora es consistente con abrirEnvioEmail
      const selecteds = this.$refs.rlist.selected;
      const pedidosMap = {};
      
      Object.values(selecteds).forEach(selected => {
        const pedidoId = selected.pedidoResumen.id;
        if (!pedidosMap[pedidoId]) {
          pedidosMap[pedidoId] = {
            id: pedidoId,
            numerosLinea: []
          };
        }
        pedidosMap[pedidoId].numerosLinea.push(selected.numero);
      });
      
      return Object.values(pedidosMap);
    },
    crearExpManualConLinea: function(idPedido, numLinea) {
      var self = this;
      var app = self.$f7;
      var jsonData = {idPedido: idPedido, numLinea: numLinea};
      jsonData = Object.values(jsonData);
        app.views.current.router.navigate(
          "/inspecciones/new/?jsonData=" + JSON.stringify(jsonData)
        );
    },
    mostrarFacturas(linea) {
      const self = this;
      self.numeroPedidoParaFactura = linea.pedidoResumen.numero;
      self.popupListadoFacturasOpened = true;
    },
    planificar: function(selecteds, esTPI = false) {
      var self = this;
      var app = self.$f7;
      var msgError = undefined;
      var jsonData = [];
      Object.values(selecteds).forEach(selected => {
        if (!selected.tipoLinea || selected.tipoLinea == "TASAS" || selected.tipoLinea == "SUBCONTRATACION") {
          msgError = "La línea " + selected.numero + " del pedido " + selected.codigo + " es de tipo " + selected.tipoLinea + " y no se puede planificar.";
          app.dialog.alert(msgError);
          return;
        } else if (!selected.direccionInspeccion) {
          msgError = "La línea " + selected.numero + " del pedido " + selected.codigo + " no tiene dirección asociada.";
          app.dialog.alert(msgError);
          return;
        } else {
          if (!jsonData[selected.pedidoResumen.id]) {
            jsonData[selected.pedidoResumen.id] = {idPedido: selected.pedidoResumen.id, numeroLineas: []};
          }
          jsonData[selected.pedidoResumen.id].numeroLineas.push(selected.numero);
        }
      });
      if (!msgError) {
        jsonData = Object.values(jsonData);
        if (esTPI) {
            app.views.current.router.navigate(
              "/pedidos/planificar-tpi/?jsonData=" + JSON.stringify(jsonData)
            );
        } else {
            app.views.current.router.navigate(
              "/pedidos/planificar/?jsonData=" + JSON.stringify(jsonData)
            );
        }
      }
    },
    verEnBC: function (bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para este pedido.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir el pedido en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=42';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    enviarBC: function (idPedido) {
      var self = this;
      var app = self.$f7;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Pedido.enviarBC({ itemId: idPedido }).then(function (res) {
        espera.cerrar();
        app.toast
          .create({
            text: self.$t("pedidos.envio_bc_ok"),
            position: "center",
            closeTimeout: 2000,
            icon: '<i class="f7-icons">checkmark_alt</i>'
          })
          .open();
        self.$refs.rlist.reload();
      }).catch(function (error) {
        espera.cerrar();
        app.dialog.alert(error.message);
      });
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    // miramos si  en la url viene el parámetro selectedReparto
    let parametros = self.$f7route.url.split('?')[1];
    let filter;
    if (parametros) {
      try {
        eval(parametros.replaceAll('&',';'));
        
      } catch(_){}
    }
  }
};
</script>